import { CssBaseline } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { DrawerContent } from './DrawerContent';
import { NavBar } from './appBar/NavBar';
import React, { useState } from 'react';

export const Layout = (props) => {
    const [mobileOpen, setMobileOpen] = useState<boolean>(false);

    const { children, menuItems, logo, ...other } = props;

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const classes = useStyles();

    return (
        <div className={classes.root}>
            <CssBaseline />
            <NavBar onClick={handleDrawerToggle} {...props} />
            <DrawerContent onClose={handleDrawerToggle} isOpened={mobileOpen} logoSrc={logo.wideSrc} {...other}>
                {menuItems}
            </DrawerContent>
            <main className={classes.content}>
                <div className={classes.toolbar} />
                {children}
            </main>
        </div>
    );
};

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex'
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3)
    },
    toolbar: theme.mixins.toolbar
}));

//type LayoutProps = Pick<IDrawerProps, 'classes'> & {
//    menuItems: ReactNode;
//} & Omit<INavBarProps, 'onClick'>;
